import React from "react";
import { DISCLAIMERS } from "@/constants/oracle";

const ORACLE_COMPLIANCE_LOCK = [
  "Educational intelligence only.",
  "Not financial advice.",
  "Not betting advice.",
  "Not medical advice.",
  "No guaranteed outcomes.",
  "Human confirmation required.",
];

export default function DisclaimerFooter() {
  return (
    <footer className="oracle-disclaimer" data-testid="oracle-disclaimer-footer">
      <div className="oracle-disclaimer__title">CARELOGIX ORACLE™ — COMPLIANCE LOCK</div>
      <ul className="oracle-disclaimer__list" data-testid="oracle-compliance-lock">
        {ORACLE_COMPLIANCE_LOCK.map((d, i) => (
          <li key={`lock-${i}`}>• {d}</li>
        ))}
      </ul>
      {DISCLAIMERS && DISCLAIMERS.length > 0 ? (
        <>
          <div className="oracle-disclaimer__title" style={{ marginTop: 14 }}>REGULATORY · RISK · INTEGRITY</div>
          <ul className="oracle-disclaimer__list">
            {DISCLAIMERS.map((d, i) => (
              <li key={i}>• {d}</li>
            ))}
          </ul>
        </>
      ) : null}
      <div className="oracle-disclaimer__brand">
        CareLogix™ ORACLE — Multi-Domain Intelligence Command™ · © {new Date().getFullYear()}
        {" · "}
        <a href="mailto:Contact@carelogix360.com" data-testid="oracle-contact-email" style={{ color: "inherit" }}>Contact@carelogix360.com</a>
        {" · "}
        <a href="tel:+18018015165" data-testid="oracle-contact-phone" style={{ color: "inherit" }}>801-801-5165</a>
      </div>
    </footer>
  );
}
